(function() {
  var checkout = document.getElementsByName('checkout')[0];
  var idme = `<div class="idme-shopify">
    <span class='idme-btn-affinity'>Government, Military, Nurses, Responders, Students, and Teachers receive a discount</span>
    <span class="idme-btn-unify">
      <a href="javascript:void(0)" onclick="idmePopUp()">
        <img src="https://s3.amazonaws.com/idme/buttons/v4/verify-with-idme.png" alt="ID.me" style="height:37px"/>
      </a>
    </span>
  </div>`;

  checkout.insertAdjacentHTML("afterend", idme);
})();

function idmePopUp() {
  var body = document.body;
  var html = document.documentElement;

  var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
  var width = Math.max( body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth );

  var top   = (height - 780) / 4;
  var left  = (width - 800) / 2;

  window.open("https://discountify.id.me/oauth/checkpoint/rhino-brand", "", "scrollbars=yes,menubar=no,status=no,location=no,toolbar=no,width=800,height=780,top=" + top + ",left=" + left);
};

var urlParams = new URLSearchParams(window.location.search)

if (urlParams.get('popup')) {
  if (window.opener) {
    window.opener.location.href = "https://rhino-brand.myshopify.com/checkout";
  	window.close();
  }
  else {
  	window.location.href = "https://rhino-brand.myshopify.com/checkout";
  }
};

if (urlParams.get('error')) {
  window.close();
};

